import React from 'react';
import styled from 'styled-components';
import { colors } from '@com/core/noon/styles/noonTheme';
import { useTranslation } from '@com/core/common/translations/i18n';

type TTagVariants = 'primary' | 'secondary' | 'tertiary' | null;

type TProps = {
    price: number;
    salePrice: number;
    variant?: TTagVariants;
};

const TagDiscount = ({ price, salePrice, variant = 'secondary' }: TProps): JSX.Element => {
    const { t } = useTranslation('common');

    const MIN_PERC_DISPLAY = 5;
    const discountPercentage = Math.floor(((price - salePrice) / price) * 100);
    let displayVal = t('_pdp_percent-off', { perc: discountPercentage });

    switch (variant) {
        case 'secondary':
            displayVal = t('_pdp_discount_percent', { perc: discountPercentage });
            break;
        case 'tertiary':
            displayVal = t('_pdp_percent-off', { perc: discountPercentage });
            break;
        default:
            break;
    }

    if (salePrice && discountPercentage > MIN_PERC_DISPLAY) {
        return (
            <Container variant={variant}>
                <span className="bg" />
                <span className="value">{displayVal}</span>
            </Container>
        );
    }

    return null;
};

const Container = styled.span<{ variant: TTagVariants }>`
    ${({ variant }): string => {
        switch (variant) {
            case 'primary':
                return `
                    color: ${colors.generalPositive};
                    text-transform: uppercase;
                    font-size: 0.75rem;
                    font-weight: bold;
                    padding: 0 4px;
                    position: relative;
                    display: inline-block;
                    line-height: 16px;

                    .bg {
                        position: absolute;
                        top: 0;
                        left: 0;
                        bottom: 0;
                        right: 0;
                        opacity: 0.2;
                        background-color: ${colors.generalPositive};
                    }

                    .value {
                        position: relative;
                    }
                    `;
            case 'secondary':
                return `
                    color: ${colors.generalPositive};
                    text-transform: uppercase;
                    font-size: 0.75rem;
                    font-weight: bold;
                    padding: 0 4px;
                    position: relative;
                    display: inline-block;
                    line-height: 16px;

                    .value {
                        position: relative;
                    }
                    `;
            case 'tertiary':
                return `
                    background: #dff1d9;
                    color: #37ae02;
                    font-weight: 900;
                    padding: 0.1em 0.5em;
                    font-size: 12px;
                    margin: 0 12px;
                    border-radius: 2px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    line-height: normal;
                    .value {
                        position: relative;
                    }
                    `;
            default:
                return '';
        }
    }}
`;

export default TagDiscount;
